import { render } from "./PageEditBot.vue?vue&type=template&id=bbf0f104"
import script from "./PageEditBot.vue?vue&type=script&lang=js"
export * from "./PageEditBot.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__